import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialBookmark1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M19.81 10.67V4.58h-1.52v25.9h1.52V12.2h9.14V3.05h-1.52v7.62zm6.1-9.14h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M19.81 3.05h1.52v1.53h-1.52Zm-3.05 27.43h1.53V32h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Zm-1.52-1.53h1.52v1.53h-1.52Zm1.52-18.28h-3.05v1.52h-1.52V9.15H7.62v1.52H6.1v3.05h1.52v1.52h1.52v1.53h1.53v1.52h1.52v-1.52h1.53v-1.53h1.52v-1.52h1.52v-3.05h-1.52zm-3.05 16.76h1.53v1.52h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Zm-1.53 1.52h1.53v1.52H9.14ZM7.62 1.53h13.71v1.52h1.53V1.53h3.05V0H7.62zm0 25.9h1.52v1.53H7.62ZM6.1 28.96h1.52v1.52H6.1Zm0-27.43h1.52v1.52H6.1ZM4.57 30.48H6.1V32H4.57Zm0-27.43H6.1v1.53H4.57ZM3.05 4.58h1.52v25.9H3.05Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialBookmark1
